import { render, staticRenderFns } from "./announcement-column.vue?vue&type=template&id=4755c61d&"
import script from "./announcement-column.vue?vue&type=script&lang=js&"
export * from "./announcement-column.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports